/* esm.sh - @radix-ui/react-aspect-ratio@1.1.8 */
export * from "/*@radix-ui/react-aspect-ratio@1.1.8/esnext/react-aspect-ratio.mjs";
